import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1ed36739&"
import script from "./script?vue&type=script&lang=js&"
export * from "./script?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports